// extracted by mini-css-extract-plugin
module.exports = {"active":"styles_active__2cYag","item":"styles_item__1B6LM","link":"styles_link__3O8vd","reportsTab":"styles_reportsTab__Hrzsd","right-menu":"styles_right-menu__3Ut_x"};